import React, { createContext, useContext, useState, useEffect } from "react";

const UIContext = createContext(null);

export const useUI = () => {
  return useContext(UIContext);
};

const getSystemTheme = () => {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

const initializeTheme = () => {
  const mode = localStorage.getItem("themeMode") || "light";
  if (!localStorage.getItem("themeMode")) {
    localStorage.setItem("themeMode", "light");
  }

  const resolvedTheme = mode === "system" ? getSystemTheme() : mode;
  localStorage.setItem("theme", resolvedTheme);
  return { theme: resolvedTheme, mode };
};

const UIProvider = ({ children }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [{ theme: initialTheme, mode: initialMode }] = useState(initializeTheme);
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  const [themeMode, setThemeMode] = useState(initialMode);

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", currentTheme);
  }, [currentTheme]);

  useEffect(() => {
    if (themeMode === "system") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleChange = (e) => {
        const newTheme = e.matches ? "dark" : "light";
        setCurrentTheme(newTheme);
        localStorage.setItem("theme", newTheme);
      };

      setCurrentTheme(getSystemTheme());
      localStorage.setItem("theme", getSystemTheme());

      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }
  }, [themeMode]);

  const toggleTheme = () => {
    const newTheme = currentTheme === "dark" ? "light" : "dark";
    setCurrentTheme(newTheme);
    setThemeMode(newTheme);
    localStorage.setItem("theme", newTheme);
    localStorage.setItem("themeMode", newTheme);
  };

  const setThemeModePreference = (mode) => {
    setThemeMode(mode);
    localStorage.setItem("themeMode", mode);

    if (mode === "system") {
      const systemTheme = getSystemTheme();
      setCurrentTheme(systemTheme);
      localStorage.setItem("theme", systemTheme);
    } else {
      setCurrentTheme(mode);
      localStorage.setItem("theme", mode);
    }
  };

  return (
    <UIContext.Provider
      value={{ 
        showLoginModal, 
        setShowLoginModal, 
        toggleTheme, 
        currentTheme, 
        themeMode, 
        setThemeModePreference 
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export default UIProvider;
